import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaResumoPrestacaoRecursoConcedidoInicio: [],
    buscaResumoPrestacaoRecursoConcedidoSucesso: ['resumoPrestacaoRecursoConcedido'],
    buscaResumoPrestacaoRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaResumoPrestacaoRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaResumoPrestacaoRecursoConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarResumoPrestacao(filtro)
            .then(response => dispatch(Creators.buscaResumoPrestacaoRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaResumoPrestacaoRecursoConcedidoErro(error)))
    }
}

const buscaResumoPrestacaoRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaResumoPrestacaoRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaResumoPrestacaoRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.resumoPrestacaoRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_RESUMO_PRESTACAO_RECURSO_CONCEDIDO_INICIO]: buscaResumoPrestacaoRecursoConcedidoInicio,
    [Types.BUSCA_RESUMO_PRESTACAO_RECURSO_CONCEDIDO_ERRO]: buscaResumoPrestacaoRecursoConcedidoErro,
    [Types.BUSCA_RESUMO_PRESTACAO_RECURSO_CONCEDIDO_SUCESSO]: buscaResumoPrestacaoRecursoConcedidoSucesso,
})
